module dg.exceptions {
    declare var JL: any;
    angular.module('dg.exceptions', ['dgUtils'])
        .config(($httpProvider: ng.IHttpProvider) => {
            $httpProvider.interceptors.push('httpErrorHandlerInterceptor');
        })
        .run(($transitions: any, dgGuid: dgUtils.DgGuid) => {
            $transitions.onSuccess({}, ($transition$, $state) => {
                JL.setOptions({
                    'requestId': dgGuid.generateGUID()
                });
            });

        });
}